import Navbar from "./Navbar";
import Background from '../Background/Background';

function Layout({ children }) {
    return(
        <>
        <Navbar />
        <div>
            <Background />
            {children}
        </div>
        </>
    )
}
export default Layout